import { lazy } from "react";
import { Outlet, RouteObject } from "react-router-dom";

import { Logout } from "@/components/Logout";
import Protected from "@/routes/Protected";

import { AdminRoutes } from "./AdminRoutes";
import { ClientRoutes } from "./ClientRoutes";
import { PracticesRoutes } from "./PracticesRoutes";
import { ScheduleRoutes } from "./ScheduleRoutes";

// Preload critical components
const SignInPage = lazy(() => import("@/SignInPage"));
const ErrorPage = lazy(() => import("@/ErrorPage"));
const NotFound = lazy(() => import("@/NotFound"));

// Single Suspense boundary for the entire app
const routes: RouteObject[] = [
  {
    errorElement: <ErrorPage />,
    children: [
      {
        element: (
          <Protected allowedRoles={["Practitioner"]} routes={["/practices", "/amend"]}>
            <Outlet />
          </Protected>
        ),
        children: [...AdminRoutes, ...PracticesRoutes, ...ClientRoutes, ...ScheduleRoutes],
      },
      { path: "*", element: <NotFound /> },
      {
        path: "/",
        element: <SignInPage />,
      },
      {
        path: "/logout",
        element: <Logout />,
      },
    ],
  },
];
export default routes;
